import { createContext } from "react";
import { Comment, Post } from "../utils/types";

export type PostInfoContextType = {
    post?: Post | Comment,
    fatherPost?: Post | Comment,
};
export const PostInfoContext = createContext<PostInfoContextType>({});